export const getCtaColor = (status: string) => {
  if (status === "delete") return "danger";
  return "secondary";
};
